/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SectionLock } from '@core/models/SectionLock';
import { InformationModalService } from '@core/services/information-modal/information-modal.service';
import { LibraryService } from '@core/services/library/library.service';
import { ModalService } from '@core/services/modal/modal.service';
import { ToastService } from '@core/services/toast/toast.service';
import { ClinicQuery } from '@core/state/clinic/clinic.query';
import { AlertController } from '@ionic/angular';

@Component({
    selector: 'app-information-modal',
    templateUrl: './information.modal.html',
    styleUrls: ['./information.modal.scss'],
    standalone: false
})
export class InformationModalComponent implements OnInit {
    @Input() headerTitle = '';
    @Input() icon = 'check';
    @Input() label = '';
    @Input() description = '';
    @Input() btnText = '';
    @Input() color = 'primary';
    @Input() section = '';

    title = '';

    constructor(
        private alertController: AlertController,
        private clinicQuery: ClinicQuery,
        private informationModalService: InformationModalService,
        private libraryService: LibraryService,
        private modalService: ModalService,
        private toastService: ToastService
    ) { }

    ngOnInit(): void {
    }

    /**
     * Comprueba si está el bloqueo activo, sino cierra el modal y envía el evento de click
     */
    closeModal(): void {
        const { sectionsLocks: { documents } } = this.clinicQuery.getActive();
        this.dismissModal();
    }

    /**
     * Abre el alert para introducir el pin para desbloquear FME
     * @param documents SectionLock
     */
    createLockAlert(documents: SectionLock) {
        this.alertController.create({
            header: this.libraryService.getLabel('lbl_key_code'),
            inputs: [
                {
                    name: 'key',
                    type: 'text'
                }
            ],
            buttons: [
                {
                    text: this.libraryService.getLabel('lbl_cancel'),
                    role: 'cancel',
                    cssClass: 'alert-cosa',
                    handler: () => {
                    }
                },
                {
                    text: this.libraryService.getLabel('lbl_accept'),
                    handler: ({ key }) => {
                        if (key === documents.code) {
                            this.dismissModal();
                        } else {
                            this.toastService.presentErrorToast(this.libraryService.getLabel('lbl_lock_key_error'));
                        }
                    }
                }
            ]
        }).then(alert => alert.present());
    }

    dismissModal() {
        this.informationModalService.emitInformationBtnClick(this.section);
        this.modalService.dismiss({ action: 'cancel' }, 'close', InformationModalId);
    }
}

export const InformationModalId = 'INFORMATION_MODAL_ID';
